import axios, { baseUrl } from '@/libs/api.request'
import { getToken } from '@/libs/util'

export const getExchangeRatePage = (params) => {
  return axios.request({
    method: 'get',
    url: '/exchangeRate/page',
    params
  })
}

export const editExchangeRate = (data) => {
  return axios.request({
    method: 'put',
    data,
    url: '/exchangeRate/edit'
  })
}

export const importExchangeRate = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/exchangeRate/import'
  })
}

// 导入 Google Earnings 账单并重算支付、退款实收。
export const recalculateGoogleEarnings = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/exchangeRate/google/earnings/recalculate'
  })
}

// 导入Apple财务账单并确认支付、退款实际实收。
export const importAppleFinancialReport = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/exchangeRate/apple/financial/import'
  })
}

// 分页查询Apple财务账单原始行和匹配结果。
export const getAppleFinancialReportPage = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/exchangeRate/apple/financial/page'
  })
}

// 重试Apple财务账单中尚未匹配成功的明细。
export const retryAppleFinancialReport = (batchId) => {
  return axios.request({
    method: 'post',
    url: `/exchangeRate/apple/financial/${batchId}/retry`
  })
}

// 流式导入Google Earnings账单，后端每处理完一笔便返回一行NDJSON。
export const recalculateGoogleEarningsStream = async (data, onEvent) => {
  const response = await fetch(`${baseUrl}/exchangeRate/google/earnings/recalculate/stream`, {
    method: 'POST',
    headers: {
      token: getToken(),
      lang: 'zh_HK',
      Accept: 'application/x-ndjson'
    },
    body: data
  })
  if (!response.ok) {
    const message = await response.text()
    throw new Error(message || `Google账单导入请求失败（${response.status}）`)
  }
  if (!response.body || !response.body.getReader) {
    throw new Error('当前浏览器不支持流式读取，请升级浏览器后重试')
  }

  const reader = response.body.getReader()
  const decoder = new TextDecoder('utf-8')
  let buffer = ''
  let summary = null

  const consumeLine = line => {
    if (!line.trim()) return
    const event = JSON.parse(line)
    if (onEvent) onEvent(event)
    if (event.eventType === 'SUMMARY') summary = event.summary
    if (event.eventType === 'ERROR') {
      throw new Error(event.message || 'Google账单处理失败')
    }
  }

  while (true) {
    const { value, done } = await reader.read()
    buffer += decoder.decode(value || new Uint8Array(), { stream: !done })
    const lines = buffer.split('\n')
    buffer = lines.pop() || ''
    lines.forEach(consumeLine)
    if (done) break
  }
  consumeLine(buffer)
  return summary
}

// 分页查询Frankfurter采集汇率。
export const getFrankfurterExchangeRatePage = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/exchange-rate/page'
  })
}

export const getRechargeTemplateConfigPage = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/pay/recharge/template/configs'
  })
}

export const addRechargeTemplateConfig = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/pay/recharge/template/configs'
  })
}

export const editRechargeTemplateConfig = (data) => {
  return axios.request({
    method: 'put',
    data,
    url: '/pay/recharge/template/configs'
  })
}

export const getRechargeTemplateEntryOptions = () => {
  return axios.request({
    method: 'get',
    url: '/pay/recharge/template/configs/entry-options'
  })
}

export const changeRechargeTemplateConfigStatus = (data) => {
  return axios.request({
    method: 'put',
    data,
    url: '/pay/recharge/template/configs/status'
  })
}

export const getRechargeTemplateConfigInfo = (id) => {
  return axios.request({
    method: 'get',
    url: '/pay/recharge/template/configs/' + id
  })
}

export const delRechargeTemplateConfig = (id) => {
  return axios.request({
    method: 'delete',
    url: '/pay/recharge/template/configs/' + id
  })
}
